// Types d'opérations de terrain du lot 3, inscrits au registre de synchronisation du serveur (architecture,
// section 8) et utilisés par l'application hors connexion. Les types du lot 2 (déclaration de stock et de
// statut) et du lot 6 (inspections, signalement d'incident) gardent leurs noms.

export const TYPES_OPERATIONS_LOT3 = {
  etapeMission: 'etape_mission',
  confirmationReception: 'confirmation_reception',
  demandeReapprovisionnement: 'demande_reapprovisionnement',
  signalementRupture: 'signalement_rupture',
  incidentStation: 'signalement_incident_station',
} as const;

export const LIBELLES_TYPES_OPERATIONS: Record<string, string> = {
  etape_mission: 'Étape de mission',
  confirmation_reception: 'Confirmation de réception',
  demande_reapprovisionnement: 'Demande de réapprovisionnement',
  signalement_rupture: 'Signalement de rupture',
  signalement_incident_station: 'Incident de station',
  declaration_stock: 'Déclaration de stock',
  declaration_statut_station: 'Déclaration de stock et de statut',
  constat_inspection: 'Constat d’inspection',
  reponses_inspection: 'Réponses d’un formulaire d’inspection',
  signalement_incident: 'Signalement d’incident',
};

/** Fenêtre de détection des conflits entre deux utilisateurs sur un même objet (cadrage, section 9). */
export const FENETRE_CONFLIT_HEURES = 12;
/** Expiration locale d'une session ouverte hors connexion (cadrage, section 9 ; R-23). */
export const EXPIRATION_SESSION_LOCALE_HEURES = 24;
/** Conservation locale d'une opération refusée avant purge (cadrage, section 9). */
export const CONSERVATION_REFUS_JOURS = 30;
